import React, { useState, useEffect, Fragment } from 'react';
import { TSTable, TSCell } from '../../ui/TableStructure';
import { Stack, TableRow, Tabs, Tab, Typography } from '@mui/material';
import { backendFetch } from '../../../backend/backend';
import ordinal, { ordinalList } from '../../../utils/ordinal';
import Selector from '../../ui/Selector';
import { XAxis, YAxis, BarChart, Bar, ResponsiveContainer, Label } from 'recharts';
import { useTheme } from '@emotion/react';
import useStickyState from '../../../utils/useStickyState';

const StatsPositions=()=>{

	const maxPositionsPixels=850;

	const [positions,setPositions]=useState();
	const [positionsGame1,setPositionsGame1]=useState();
	const [positionsGame2,setPositionsGame2]=useState();
	const [host,setHost]=useStickyState("","statsPositionsHost");
	const [players,setPlayers]=useState();
	const [fetched,setFetched]=useState(false);
	const [tab,setTab]=useStickyState(0,"statsPositionsTab",{sessionOnly:true});

	useEffect(()=>{
		const fetchData=async ()=>{
			setPlayers((await backendFetch('players')).map((p)=>p.name));
			setPositions(await backendFetch('stats/positions?host='+host));
			setPositionsGame1(await backendFetch('stats/positions?game=1&host='+host));
			setPositionsGame2(await backendFetch('stats/positions?game=2&host='+host));
			setFetched(true);
		}
		fetchData();
	},[host]);

	const PositionsGraphData=(playerPositions)=> {
		var numPositions=0;
		playerPositions.forEach((p)=>{if (p.positions.length>numPositions) numPositions=p.positions.length})
		const graphData=playerPositions.map((p)=>{
			const posEntries=Array.from({length:numPositions},(_,i)=>i).map((c)=>(p.positions[c]||0)*100/p.games);
			return {
				player: p.player,
				positions: posEntries
			};
		});
		return ({numPositions,graphData});
	}

	const PositionsTable=({playerPositions,title})=>{
		var numPositions=0;
		playerPositions.forEach((p)=>{if (p.positions.length>numPositions) numPositions=p.positions.length})
		const headings=["Player","Played"];
		headings.push(...ordinalList(numPositions));
		const rows=playerPositions.map((p)=>{
			const posCols=Array.from({length:numPositions},(_,i)=>i).map((c,j)=>(
				<TSCell sx={{width:`${(maxPositionsPixels/numPositions).toFixed(0)}px`}} key={j}>{`${((p.positions[c]||0)*100/p.games).toFixed(1)}%`}</TSCell>

			))
			return(
				<TableRow key={p.player}>
					<TSCell>{p.player}</TSCell>
					<TSCell>{p.games}</TSCell>
					{posCols}
				</TableRow>
			);
		});
		return(
			<TSTable headings={headings} title={title}>
				{rows}
			</TSTable>
		);
	}

	const barColors=["#ff0000","#ff8800","#ffff00","#00ff00","#00ffff","#4444ff","#ff00ff"];

	const TabPanel=({children,value,index})=>{
		return(
			<Fragment>
				{value === index && children }
			</Fragment>
		)
	}

	const theme=useTheme();
	const PositionsGraph=({playerPositions,title})=>{
		const {numPositions,graphData}=PositionsGraphData(playerPositions);
		return(
			<Stack spacing={0}>
				<Typography variant="h4">{title}</Typography>
				<ResponsiveContainer width="100%" height={400}>
					<BarChart data={graphData} layout="vertical">
						{Array.from({length:numPositions},(_,i)=>i).map((i)=>(
							<Bar key={i} type="monotone" dataKey={`positions[${i}]`} stroke={theme.palette.text.primary} fill={barColors[i]} stackId="a" isAnimationActive={false}/>
						))}
						<YAxis type="category" dataKey="player" width={80} stroke={theme.palette.text.primary}/>
						<XAxis
							height={70}
							type="number"
							stroke={theme.palette.text.primary}
							label={<Label value="% of games" fill={theme.palette.text.primary}/>}
							domain={[0,100.0]}
							ticks={[0,20,40,60,80,100]}/>
					</BarChart>
				</ResponsiveContainer>
			</Stack>
		)
	};
	
	const hostDisplay=()=>(host===""?"(All venues)":`(Venue: ${host})`)

	return(
		<Stack>
			{fetched &&
				<Fragment>
					<Selector label="Host" values={players} value={host} onChange={(v)=>setHost(v)} clearItem />
					<Tabs value={tab} onChange={(event,newValue)=>setTab(newValue)}>
						<Tab label="Tables"/>
						<Tab label="Charts"/>
					</Tabs>
					<TabPanel value={tab} index={0}>
					<PositionsTable title={"All Games Positions "+hostDisplay()} playerPositions={positions}></PositionsTable>
					<PositionsTable title={"1st Game Positions "+hostDisplay()} playerPositions={positionsGame1}></PositionsTable>
					<PositionsTable title={"2nd Game Positions "+hostDisplay()} playerPositions={positionsGame2}></PositionsTable>
					</TabPanel>
					<TabPanel value={tab} index={1}>
					<PositionsGraph title={"All Games Positions "+hostDisplay()} playerPositions={positions}></PositionsGraph>
					<PositionsGraph title={"1st Game Positions "+hostDisplay()} playerPositions={positionsGame1}></PositionsGraph>
					<PositionsGraph title={"2nd Game Positions "+hostDisplay()} playerPositions={positionsGame2}></PositionsGraph>
					<TSTable title="Key" sx={{maxWidth:800,width:{lg:800}}}>
						<TableRow>
							{barColors.map((col,i)=> <TSCell key={i} sx={{backgroundColor:col,color:"black"}}>{ordinal(i+1)}</TSCell>)}
						</TableRow>
					</TSTable>
					</TabPanel>
				</Fragment>
			}
		</Stack>
	);
};

export default StatsPositions;
